const SORT_BY_MEDIA = {
  all: 'most-recent',
  photo: 'with-pictures',
  video: 'videos-first',
};

class JudgemeReviewFilter extends HTMLElement {
  connectedCallback() {
    this.widget = this.querySelector('.jdgm-all-reviews-page');
    this.empty = this.querySelector('.reviews-wall__empty');
    this.tabs = Array.from(this.querySelectorAll('[data-media-tab]'));
    if (!this.widget || this.tabs.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab.dataset.mediaTab));
    });

    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(this.widget, { childList: true, subtree: true });

    this.refresh();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  select(media) {
    if (!SORT_BY_MEDIA[media]) return;

    this.dataset.media = media;
    this.tabs.forEach((tab) => {
      const active = tab.dataset.mediaTab === media;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.refresh();
  }

  refresh() {
    this.syncDropdown();
    this.toggleEmptyState();
  }

  get storeIsEmpty() {
    const header = this.widget.querySelector('.jdgm-all-reviews__header');
    return header ? Number.parseInt(header.dataset.numberOfReviews, 10) === 0 : false;
  }

  get isLoading() {
    const spinner = this.widget.querySelector('.jdgm-spinner');
    return spinner ? spinner.offsetParent !== null : false;
  }

  syncDropdown() {
    const dropdown = this.widget.querySelector(
      '.jdgm-rev-widg__sort-wrapper select.jdgm-sort-dropdown'
    );
    const wanted = SORT_BY_MEDIA[this.dataset.media];
    if (!dropdown || !wanted || dropdown.value === wanted) return;
    if (!dropdown.querySelector(`option[value="${wanted}"]`)) return;

    dropdown.value = wanted;
    dropdown.dispatchEvent(new Event('change', { bubbles: true }));
  }

  toggleEmptyState() {
    this.classList.toggle('reviews-wall__reviews--empty-store', this.storeIsEmpty);
    if (!this.empty) return;

    if (this.storeIsEmpty || this.isLoading) {
      this.empty.hidden = true;
      return;
    }

    const reviews = this.widget.querySelectorAll('.jdgm-all-reviews__body .jdgm-rev');
    const visible = Array.from(reviews).some((review) => review.offsetParent !== null);
    this.empty.hidden = visible;
  }
}

if (!customElements.get('judgeme-review-filter')) {
  customElements.define('judgeme-review-filter', JudgemeReviewFilter);
}
